import { stringify } from 'query-string';

import { sortOrderTypes } from 'types/shared';

interface ISocialKPIURLArgs {
  download?: boolean;
  entityIds: string[];
  isMainMetricFilter?: boolean;
  platformFilter?: string;
  sortBy?: string;
  sortOrder?: sortOrderTypes;
}

export default function getSocialKPIURL(args: ISocialKPIURLArgs): string {
  const {
    download,
    entityIds,
    isMainMetricFilter,
    platformFilter,
    sortBy,
    sortOrder,
  } = args;

  const params = stringify({
    download,
    isMainMetricFilter,
    platformFilter,
    sortBy,
    sortOrder,
  });

  return `/api/social/kpi/artist/${entityIds}?${params}`;
}
